module.exports = "<style>.width100{width:100vw}@media screen and (max-width:600px){.width100{width:480px}}</style> <meta name=HandheldFriendly content=True> <meta name=MobileOptimized content=480> <meta name=viewport content=\"width=100%\"> <img class=width100 ng-src={{vm.img_contact_us_page}}> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/contact/contact.html
// module id = 435
// module chunks = 0